// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__HLE2f","header":"ReportDetails_header__3Ntn-","title":"ReportDetails_title__2pF8Y","left":"ReportDetails_left__3POuq"};